/**
 * Vitals Product Labels injects PRE-OWNED pills on collection cards after page load.
 * Condition is shown in the card text row instead — strip any overlay labels.
 */
(() => {
  const LABEL_RE = /^(PRE-OWNED|MADE TO ORDER|BEST SELLER|NEW|SALE|ONE AVAILABLE)$/i;
  const SKIP_SELECTOR = 'img, picture, source, svg, video';

  function isLabelElement(el) {
    if (!(el instanceof HTMLElement)) return false;
    if (el.matches(SKIP_SELECTOR)) return false;
    if (el.querySelector(SKIP_SELECTOR)) return false;

    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!LABEL_RE.test(text)) return false;

    return el.closest('.product-card__figure, .product-card__media') != null;
  }

  function stripVitalsLabels() {
    document.querySelectorAll('.template-collection .product-card__figure').forEach((figure) => {
      figure.querySelectorAll('*').forEach((el) => {
        if (isLabelElement(el)) el.remove();
      });
    });
  }

  function watchCollectionGrid() {
    document.querySelectorAll('.shopify-section--main-collection').forEach((section) => {
      const observer = new MutationObserver(() => stripVitalsLabels());
      observer.observe(section, { childList: true, subtree: true });
    });
  }

  function init() {
    stripVitalsLabels();
    watchCollectionGrid();
    window.setTimeout(stripVitalsLabels, 100);
    window.setTimeout(stripVitalsLabels, 500);
    window.setTimeout(stripVitalsLabels, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['vitals:RenderProductLabels', 'vitals:ProductCardsDetected', 'load'].forEach((eventName) => {
    document.addEventListener(eventName, stripVitalsLabels);
  });
})();
